import React from 'react';
import AhriV6Widget from '../../../ahri_v6/src/AhriV6Widget.jsx';
import '../../../ahri_v6/src/ahri-system-shop-widget.css';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL } from '../config';

export default function AhriSystemShopV3() {
  const { apiKey, account } = useAuth();

  const isOAuth = Boolean(account?.accountId);

  return (
    <div style={{ margin: '-1rem -1rem -1rem -1rem' }}>
      <AhriV6Widget
        apiEndpoint={API_BASE_URL}
        {...(isOAuth ? { accessToken: apiKey } : { apiKey })}
        accountId={account?.accountId ?? account?.id ?? ""}
        routeContext="ahri/shop/v3"
        title="AHRI System Shop"
      />
    </div>
  );
}
